import * as React from 'react';
import styled from 'styled-components';
import { TextElementRow } from '../../../surveys/TextElementRow';
import { IPageFlowElementDesignRowProps } from './DraggablePageFlowElementRow';
import { DraggablePageFlowElementRow2 } from './DraggablePageFlowElementRow2';

export const WrappingTextElementRow = styled(TextElementRow)`
	overflow-wrap: anywhere;
	word-break: normal;
`;
WrappingTextElementRow.displayName = 'WrappingTextElementRow';

export const DraggableDescriptionTextRow2 = (props: IPageFlowElementDesignRowProps) => {
	return (
		<DraggablePageFlowElementRow2
			element={props.element}
			index={props.index}
			pageFlowValidationHelper={props.pageFlowValidationHelper}
			onEdit={props.onEdit}
			onDelete={props.onDelete}
		>
			<WrappingTextElementRow text={props.element.text.textValue} />
		</DraggablePageFlowElementRow2>
	);
};
